import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";

import "./styles/fonts.css";
import "./styles/tokens.css";
import "./styles/base.css";

import { App } from "./App";
import { queryClient } from "./lib/queryClient";
import { ToastProvider } from "./components/Toast/Toast";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
